'use strict';

(function () {
  angular
    .module('specsguardApp')
    .service('SgElementDialogService', SgElementDialogService);
  
  SgElementDialogService.$inject = ['$mdDialog', 'Labels'];

  function SgElementDialogService ($mdDialog, Labels) {

    return {
      open: openEditModal
    };

    function openEditModal (ev, action, selectedElement, modules, options) {

      // Default options
      let localOptions = {
        title: Labels.getLabel(`${action}specification`),
        element: selectedElement ? angular.copy(selectedElement) : null,
        modules: modules,
        projectLevel: 0,
        appSection: 'template',
        action: action,
        showElementsNav: action === 'edit'
      };

      // merge default options with new options
      if (options) {
        localOptions = Object.assign(localOptions, options);
      }

      return $mdDialog.show({
        controller: 'SgElementDialogCtrl',
        controllerAs: '$SgElementDialogCtrl',
        locals: localOptions,
        bindToController: true,
        templateUrl: 'app-legacy/components/sg-element-dialog/sg-element-dialog.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }
  }
})();
